import {reactive} from 'sitekit-extensions'

export default function puzzleController (Site, $) {
  Site.widget('puzzle-controller', {
    use: [ reactive() ],
    options: {
      answers: []
    },
    _create () {
      this.puzzleAnswers = this.element.find('.puzzle-answers')

      const answers = this.options.products.map(x => x.name.toLowerCase())

      this.state = {
        answers,
        found: []
      }
    },
    findWord (foundWord) {
      const found = []

      this.state.answers.forEach(answer => {
        const word = answer.toLowerCase().replace(/ /g, '')
        if (word === foundWord) {
          found.push(answer)
        }
      })
      
      if (found.length) {
        this.setState({
          found: [
            ...found,
            ...this.state.found
          ]
        })
      }

      return Boolean(found.length)
    },
    getProducts () {
      return this.options.products
    },
    react () {
      this.changed('found', prevState => {
        if (Object.keys(prevState).length === 0) return

        const words = this.puzzleAnswers.find('[data-word]').toArray()

        words.forEach(el => {
          const $el = $(el)

          const { word } = $el.data()
          $el.toggleClass('found', this.state.found.includes(word))
        })

        this.puzzleSlider = Site.findWidget('slider')

        if (this.puzzleSlider) {
          this.puzzleSlider.find(`[data-name="${this.state.found[0]}"]`)
        }
      })

      this.changed('answers', prevState => {
        this.puzzleAnswers.empty()

        const $answers = this.state.answers.map(ans => {
          return $(`
          <div
          data-word="${ans.toLowerCase()}"
          class="puzzle-answer copy copy--puzzle-answer col-6 col-sm-3"
          ><span>${ans}</span></div>`)
        })

        this.puzzleAnswers.append($answers)
      })
    }
  })
}
